import { useState, useMemo, useDebugValue } from "react";
import useResizeObserver from "use-resize-observer/polyfilled";
import debounce from "lodash/debounce";
export function useHeight(wait) {
    const [value, rawSet] = useState();
    const set = useMemo(() => (wait ? debounce(rawSet, wait, { leading: true }) : rawSet), [wait]);
    const { ref } = useResizeObserver({
        onResize: size => {
            set(size.height);
        }
    });
    useDebugValue(value);
    return [ref, value];
}
//# sourceMappingURL=useHeight.js.map